// DOM skeleton required by @filuet/widget IIFE (mirrors services/widget/index.html body).
export const DELIVERY_WIDGET_BODY_HTML = `
<div class="page-top">
  <div class="lang-switch" role="group" aria-label="Language">
    <button type="button" class="lang-switch__btn" data-lang="ru">RU</button>
    <button type="button" class="lang-switch__btn" data-lang="en">EN</button>
  </div>
</div>

<div class="delivery-type-section">
  <p class="delivery-type-label" data-i18n="deliveryTypeLabel">Delivery type</p>
  <div
    id="delivery-type-row"
    class="delivery-type-row is-loading"
    role="group"
    aria-label="Delivery type"
    data-i18n-loading="loading"
  >
    Loading…
  </div>
  <p id="delivery-type-error" class="delivery-type-error" hidden></p>
</div>

<div class="delivery-address-section">
  <p class="delivery-type-label" data-i18n="activeAddressLabel">Delivery address</p>
  <div id="delivery-address-card" class="delivery-address-card is-loading">
    Loading address…
  </div>
  <button
    type="button"
    id="delivery-address-edit"
    class="delivery-address__edit"
    data-i18n="changeAddressTitle"
    hidden
  >
    Edit address
  </button>
</div>

<div id="shipping-rates-section" class="shipping-rates-section" hidden>
  <p class="delivery-type-label" data-i18n="shippingRatesLabel">Shipping options</p>
  <div id="shipping-rates-panel" class="shipping-rates-panel" hidden></div>
  <button
    type="button"
    id="shipping-rates-confirm"
    class="shipping-rates-confirm"
    hidden
    disabled
  >
    <span class="shipping-rates-confirm__label" data-i18n="confirm">Confirm</span>
    <span class="shipping-rates-confirm__spinner" hidden aria-hidden="true"></span>
  </button>
  <p id="shipping-rates-confirm-error" class="shipping-rates-confirm__error" hidden></p>
</div>

<div id="address-modal" class="address-modal" hidden>
  <div class="address-modal__backdrop" data-action="close-modal"></div>
  <div
    class="address-modal__panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="address-modal-title"
  >
    <h2 id="address-modal-title" class="address-modal__title" data-i18n="changeAddressTitle">
      Edit address
    </h2>
    <div id="address-modal-filter-wrap" class="address-modal__filter">
      <input
        type="search"
        id="address-modal-filter"
        class="address-modal__filter-input"
        data-i18n-placeholder="addressFilterPlaceholder"
        autocomplete="off"
        enterkeyhint="search"
      />
    </div>
    <div id="address-modal-list" class="address-modal__list"></div>
    <div class="address-modal__actions">
      <p id="address-modal-error" class="address-modal__error" hidden></p>
      <div class="address-modal__actions-row">
        <button type="button" id="address-modal-add" class="address-modal__add" hidden>
          Add
        </button>
        <button type="button" id="address-modal-confirm" class="address-modal__confirm" data-i18n="done">
          Done
        </button>
      </div>
    </div>
  </div>
</div>

<div id="new-address-modal" class="new-address-modal" hidden>
  <div class="new-address-modal__backdrop" data-action="close-new-address-modal"></div>
  <div
    class="new-address-modal__panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="new-address-modal-title"
  >
    <h2 id="new-address-modal-title" class="new-address-modal__title" data-i18n="newAddressTitle">
      New address
    </h2>
    <form id="new-address-form" class="new-address-modal__form">
      <div class="new-address-modal__field">
        <span class="new-address-modal__label" data-i18n="deliveryTypeLabel">Delivery type</span>
        <div
          id="new-address-delivery-type-row"
          class="delivery-type-row new-address-modal__delivery-type-row"
          role="group"
          aria-label="Delivery type"
        ></div>
      </div>
      <div class="new-address-modal__field-row new-address-modal__location-row">
        <div class="new-address-modal__field new-address-modal__field--country">
          <span class="new-address-modal__label" data-i18n="newAddressCountry">Country</span>
          <div class="new-address-modal__combobox new-address-modal__combobox--country">
            <span
              id="new-address-country-flag"
              class="new-address-modal__country-input-flag fi"
              aria-hidden="true"
              hidden
            ></span>
            <input
              class="new-address-modal__input new-address-modal__combobox-input"
              name="country"
              type="text"
              autocomplete="off"
              role="combobox"
              aria-expanded="false"
              aria-controls="new-address-country-listbox"
              aria-autocomplete="list"
              required
            />
            <ul
              id="new-address-country-listbox"
              class="new-address-modal__combobox-list new-address-modal__combobox-list--country"
              role="listbox"
              hidden
            ></ul>
          </div>
        </div>
        <label class="new-address-modal__field new-address-modal__field--city">
          <span class="new-address-modal__label" data-i18n="newAddressCity">City</span>
          <div class="new-address-modal__combobox">
            <input
              class="new-address-modal__input new-address-modal__combobox-input"
              name="city"
              type="text"
              autocomplete="off"
              role="combobox"
              aria-expanded="false"
              aria-controls="new-address-city-listbox"
              aria-autocomplete="list"
              required
            />
            <ul
              id="new-address-city-listbox"
              class="new-address-modal__combobox-list new-address-modal__combobox-list--city"
              role="listbox"
              hidden
            ></ul>
          </div>
        </label>
      </div>
      <label
        class="new-address-modal__field new-address-modal__field--pickup-point"
        id="new-address-pickup-point-field"
        hidden
      >
        <span class="new-address-modal__label" data-i18n="newAddressPickupPoint">Pickup point</span>
        <div class="new-address-modal__combobox">
          <input
            class="new-address-modal__input new-address-modal__combobox-input"
            name="pickupPoint"
            type="text"
            autocomplete="off"
            role="combobox"
            aria-expanded="false"
            aria-controls="new-address-pickup-point-listbox"
            aria-autocomplete="list"
          />
          <ul
            id="new-address-pickup-point-listbox"
            class="new-address-modal__combobox-list new-address-modal__combobox-list--pickup-point"
            role="listbox"
            hidden
          ></ul>
        </div>
      </label>
      <label class="new-address-modal__field" id="new-address-address-field">
        <span class="new-address-modal__label" data-i18n="newAddressLine">Address</span>
        <input class="new-address-modal__input" name="address" type="text" required />
      </label>
      <p id="new-address-postal-code-error" class="new-address-modal__field-error" role="alert" hidden></p>
      <div class="new-address-modal__field-row new-address-modal__contact-row">
        <label class="new-address-modal__field">
          <span class="new-address-modal__label" data-i18n="newAddressContactFirstName">First name</span>
          <input
            class="new-address-modal__input"
            name="contactFirstName"
            type="text"
            autocomplete="given-name"
            required
          />
        </label>
        <label class="new-address-modal__field">
          <span class="new-address-modal__label" data-i18n="newAddressContactLastName">Last name</span>
          <input
            class="new-address-modal__input"
            name="contactLastName"
            type="text"
            autocomplete="family-name"
            required
          />
        </label>
      </div>
      <div class="new-address-modal__field-row new-address-modal__contact-row">
        <label class="new-address-modal__field">
          <span class="new-address-modal__label" data-i18n="newAddressContactEmail">Email</span>
          <input
            class="new-address-modal__input"
            name="contactEmail"
            type="email"
            autocomplete="email"
            inputmode="email"
            required
          />
        </label>
        <label class="new-address-modal__field">
          <span class="new-address-modal__label" data-i18n="newAddressContactPhone">Phone</span>
          <div class="new-address-modal__phone-input" id="new-address-contact-phone-field">
            <span
              id="new-address-contact-phone-flag"
              class="new-address-modal__phone-flag fi"
              aria-hidden="true"
            ></span>
            <input
              class="new-address-modal__input new-address-modal__phone-control"
              name="contactPhone"
              type="tel"
              autocomplete="tel"
              required
            />
          </div>
        </label>
      </div>
    </form>
    <div id="new-address-map" class="new-address-modal__map" aria-hidden="false"></div>
    <p id="new-address-modal-error" class="new-address-modal__error" role="alert" hidden></p>
    <div class="new-address-modal__actions">
      <button type="button" id="new-address-modal-cancel" class="new-address-modal__cancel" data-i18n="cancel">
        Cancel
      </button>
      <button type="button" id="new-address-modal-save" class="new-address-modal__save" data-i18n="save">
        Save
      </button>
    </div>
  </div>
</div>

<div id="widget-error-popup" class="widget-error-popup" hidden>
  <div class="widget-error-popup__backdrop"></div>
  <div
    class="widget-error-popup__panel"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="widget-error-popup-message"
  >
    <p id="widget-error-popup-message" class="widget-error-popup__message"></p>
  </div>
</div>
`.trim();
